import http from './http';

export function getToCreateSAPOrderCount() {
  return http.get('/ReplacementRequest/GetToCreateSAPOrderCount');
}

export function getToCreateSAPOrderPagingList(query) {
  return http.post('/ReplacementRequest/GetToCreateSAPOrderPagingList', query);
}
